/* Ottica Buglione — runtime nativo Shopify (sostituisce Smootify)
   Carrello AJAX + drawer, ricerca predittiva, varianti prodotto,
   filtri collezione, upsell carrello, pop-up. */
(function () {
  'use strict';
  var O = window.Ottica || {};

  /* ---------- utils ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var format = O.moneyFormat || '&euro;{{amount_with_comma_separator}}';
    var amount;
    if (format.indexOf('amount_with_comma_separator') !== -1) {
      amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    } else if (format.indexOf('amount_no_decimals') !== -1) {
      amount = Math.round(cents / 100).toString();
    } else {
      amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    }
    var html = format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent;
  }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- cart ---------- */
  function refreshCartUI(openDrawer) {
    return fetch(O.rootUrl + '?sections=header')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections.header;
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-cart-items]', '[data-cart-count]', '[data-cart-total]'].forEach(function (sel) {
          var from = doc.querySelector(sel), to = document.querySelector(sel);
          if (from && to) {
            if (sel === '[data-cart-items]') to.replaceWith(from);
            else to.textContent = from.textContent;
          }
        });
        var newForm = doc.querySelector('[data-cart-form]');
        var newEmpty = doc.querySelector('[data-cart-empty]');
        var form = document.querySelector('[data-cart-form]');
        var empty = document.querySelector('[data-cart-empty]');
        if (form && newForm) form.style.display = newForm.style.display;
        if (empty && newEmpty) empty.style.display = newEmpty.style.display;
        // aggiorna anche la pagina carrello, se presente
        var cartPage = document.querySelector('[data-cart-page]');
        if (cartPage) {
          fetch(location.pathname + '?sections=main-cart')
            .then(function (r) { return r.json(); })
            .then(function (s) {
              if (!s['main-cart']) return;
              var d = new DOMParser().parseFromString(s['main-cart'], 'text/html');
              var fresh = d.querySelector('[data-cart-page]');
              if (fresh) cartPage.replaceWith(fresh);
            });
        }
        loadCartUpsell();
        if (openDrawer) openCartDrawer();
      });
  }

  function openCartDrawer() {
    var cartEl = document.querySelector('smootify-cart[data-open="on-add"]');
    if (!cartEl) return;
    var toggle = cartEl.querySelector('.w-dropdown-toggle');
    if (!toggle || toggle.classList.contains('w--open')) return;
    if (window.jQuery) {
      window.jQuery(toggle).trigger('tap');
    } else {
      toggle.classList.add('w--open');
      var list = cartEl.querySelector('.w-dropdown-list');
      if (list) list.classList.add('w--open');
    }
  }

  function cartRequest(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function bindCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
        e.preventDefault();
        var fd = new FormData(form);
        var btn = form.querySelector('[type="submit"]');
        var prev = btn ? (btn.value || btn.textContent) : '';
        if (btn) { btn.disabled = true; if (btn.dataset.wait) { if (btn.value) btn.value = btn.dataset.wait; else btn.textContent = btn.dataset.wait; } }
        fetch(O.cartAddUrl + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
          .then(function () { return refreshCartUI(true); })
          .catch(function (err) { alert((err && err.description) || 'Impossibile aggiungere al carrello'); })
          .finally(function () {
            if (btn) { btn.disabled = false; if (btn.value) btn.value = prev; else btn.textContent = prev; }
          });
      }
    });

    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-action]');
      if (!el) return;
      var action = el.getAttribute('data-action');
      var line = el.closest('cart-item');
      if (action === 'remove' && line) {
        e.preventDefault();
        cartRequest(O.cartChangeUrl + '.js', { id: line.dataset.lineKey, quantity: 0 }).then(function () { refreshCartUI(false); });
        return;
      }
      if (action === 'plus' || action === 'minus') {
        var qi = el.closest('quantity-input');
        if (!qi) return;
        e.preventDefault();
        var input = qi.querySelector('input[type="number"]');
        var val = parseInt(input.value || '1', 10) || 1;
        val = action === 'plus' ? val + 1 : Math.max(line ? 0 : 1, val - 1);
        input.value = val;
        if (line) {
          cartRequest(O.cartChangeUrl + '.js', { id: line.dataset.lineKey, quantity: val }).then(function () { refreshCartUI(false); });
        } else {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (input.matches('cart-item input[type="number"]')) {
        var line = input.closest('cart-item');
        var val = Math.max(0, parseInt(input.value || '0', 10) || 0);
        cartRequest(O.cartChangeUrl + '.js', { id: line.dataset.lineKey, quantity: val }).then(function () { refreshCartUI(false); });
      }
    });
  }

  /* ---------- upsell carrello ---------- */
  function loadCartUpsell() {
    var slot = document.querySelector('[data-upsell-slot]');
    var tpl = document.querySelector('template[data-upsell-template]');
    var box = document.querySelector('[data-cart-upsell]');
    if (!slot || !tpl || !box) return;
    fetch(O.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) { slot.innerHTML = ''; return; }
      var pid = cart.items[0].product_id;
      return fetch(O.rootUrl + 'recommendations/products.json?product_id=' + pid + '&limit=4')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var inCart = cart.items.map(function (i) { return i.product_id; });
          var rec = (data.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1; })[0];
          slot.innerHTML = '';
          if (!rec) return;
          var node = tpl.content.cloneNode(true);
          var a = node.querySelector('[data-upsell-url]');
          a.href = rec.url;
          var img = node.querySelector('[data-upsell-image]');
          if (rec.featured_image) img.src = rec.featured_image; else img.remove();
          node.querySelector('[data-upsell-title]').textContent = rec.title;
          node.querySelector('[data-upsell-vendor]').textContent = rec.vendor;
          node.querySelector('[data-upsell-price]').textContent = formatMoney(rec.price);
          if (rec.compare_at_price && rec.compare_at_price > rec.price) {
            var c = node.querySelector('[data-upsell-compare]');
            c.textContent = formatMoney(rec.compare_at_price);
            c.style.display = '';
          }
          slot.appendChild(node);
        });
    }).catch(function () {});
  }

  /* ---------- ricerca predittiva ---------- */
  function bindSearch() {
    var input = document.querySelector('[data-search-input]');
    if (!input) return;
    var wrap = document.querySelector('search-with-query');
    var results = document.querySelector('[data-search-results]');
    var tpl = document.querySelector('template[data-search-template]');
    var emptyEl = document.querySelector('search-empty');
    var sugBox = document.querySelector('search-suggestions');
    var sugList = document.querySelector('[data-search-suggestions]');
    if (!wrap || !results || !tpl) return;

    var run = debounce(function () {
      var q = input.value.trim();
      if (!q) { wrap.style.display = 'none'; return; }
      fetch(O.predictiveSearchUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources.results.products || []);
          var queries = (data.resources.results.queries || []);
          wrap.style.display = 'block';
          results.querySelectorAll('a').forEach(function (n) { n.remove(); });
          products.forEach(function (p) {
            var node = tpl.content.cloneNode(true);
            node.querySelector('[data-result-url]').href = p.url;
            var img = node.querySelector('[data-result-image]');
            if (p.image) img.src = p.image; else img.remove();
            node.querySelector('[data-result-title]').textContent = p.title;
            node.querySelector('[data-result-vendor]').textContent = p.vendor || '';
            node.querySelector('[data-result-price]').textContent = formatMoney(Math.round(parseFloat(p.price) * 100));
            results.appendChild(node);
          });
          if (emptyEl) emptyEl.style.display = products.length ? 'none' : 'block';
          if (sugBox && sugList) {
            sugList.innerHTML = '';
            queries.forEach(function (s) {
              var a = document.createElement('a');
              a.href = O.searchUrl + '?q=' + encodeURIComponent(s.text) + '&type=product';
              a.textContent = s.text;
              sugList.appendChild(a);
            });
            sugBox.style.display = queries.length ? 'block' : 'none';
          }
          var dropToggle = input.closest('.w-dropdown') && input.closest('.w-dropdown').querySelector('.w-dropdown-toggle');
          var dropList = input.closest('.w-dropdown') && input.closest('.w-dropdown').querySelector('.w-dropdown-list');
          if (dropToggle && dropList && !dropList.classList.contains('w--open')) {
            dropToggle.classList.add('w--open');
            dropList.classList.add('w--open');
          }
        })
        .catch(function () {});
    }, 250);
    input.addEventListener('input', run);
  }

  /* ---------- varianti prodotto ---------- */
  function bindProduct() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      var dataEl = root.querySelector('[data-variants-json]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var state = {};
      root.querySelectorAll('[data-option-index]').forEach(function (ctrl) {
        var idx = ctrl.getAttribute('data-option-index');
        if (ctrl.tagName === 'SELECT') {
          state[idx] = ctrl.value;
          ctrl.addEventListener('change', function () { state[idx] = ctrl.value; update(); });
        } else {
          var current = ctrl.querySelector('[data-swatch].is-active');
          if (current) state[idx] = current.getAttribute('data-value');
          ctrl.addEventListener('click', function (e) {
            var sw = e.target.closest('[data-swatch]');
            if (!sw) return;
            e.preventDefault();
            ctrl.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
            sw.classList.add('is-active');
            state[idx] = sw.getAttribute('data-value');
            update();
          });
        }
      });
      function update() {
        var match = variants.find(function (v) {
          return Object.keys(state).every(function (i) {
            return v.options[parseInt(i, 10) - 1] === state[i];
          });
        });
        var product = root.closest('smootify-product');
        if (!match) {
          if (product) product.classList.add('not-existing-variant');
          return;
        }
        if (product) {
          product.classList.remove('not-existing-variant');
          product.classList.toggle('is-available', match.available);
          product.classList.toggle('is-not-available', !match.available);
          product.classList.toggle('is-on-sale', !!(match.compare_at_price && match.compare_at_price > match.price));
        }
        if (idInput) idInput.value = match.id;
        var priceEl = root.querySelector('[data-variant-price]');
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        var compareEl = root.querySelector('[data-variant-compare]');
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        var btn = root.querySelector('[type="submit"]');
        if (btn) {
          btn.disabled = !match.available;
          var label = btn.getAttribute('data-label-add') || 'Aggiungi al carrello';
          var sold = btn.getAttribute('data-label-sold') || 'Esaurito';
          if (btn.value !== undefined && btn.tagName === 'INPUT') btn.value = match.available ? label : sold;
          else btn.textContent = match.available ? label : sold;
        }
        if (match.featured_image && match.featured_image.src) {
          var gallery = document.querySelector('[data-main-media]');
          if (gallery) {
            var target = document.querySelector('[data-media-id="' + match.featured_image.id + '"]');
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
        }
      }
      update();
    });
  }

  /* ---------- filtri collezione ---------- */
  function bindFilters() {
    var box = document.querySelector('smootify-search-discovery[data-section-id]');
    if (!box) return;
    var sectionId = box.getAttribute('data-section-id');

    function apply(params, push) {
      var url = location.pathname + (params.toString() ? '?' + params.toString() : '');
      fetch(url + (params.toString() ? '&' : '?') + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-filter-grid]');
          var cur = document.querySelector('[data-filter-grid]');
          if (fresh && cur) cur.replaceWith(fresh);
          var freshCount = doc.querySelector('[filter="count"]');
          var curCount = document.querySelector('[filter="count"]');
          if (freshCount && curCount) curCount.textContent = freshCount.textContent;
          if (push !== false) history.pushState({}, '', url);
        });
    }

    function currentParams() {
      var params = new URLSearchParams(location.search);
      params.delete('page');
      params.delete('section_id');
      return params;
    }

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-filter-param]')) {
        var params = currentParams();
        var key = t.getAttribute('data-filter-param');
        if (key === '__collection__') {
          if (t.value) location.href = t.value;
          return;
        }
        params.delete(key);
        if (t.value) params.append(key, t.value);
        apply(params);
      }
      if (t.matches('[data-sort-select]')) {
        var p2 = currentParams();
        p2.delete('sort_by');
        if (t.value) p2.set('sort_by', t.value);
        apply(p2);
      }
    });

    // ricerca testuale: filtra le card visibili nella griglia corrente
    var fs = box.querySelector('[data-grid-search]');
    if (fs) {
      fs.addEventListener('input', debounce(function () {
        var q = fs.value.trim().toLowerCase();
        box.querySelectorAll('[data-filter-grid] smootify-product').forEach(function (card) {
          var txt = (card.textContent || '').toLowerCase();
          card.style.display = !q || txt.indexOf(q) !== -1 ? '' : 'none';
        });
      }, 200));
    }

    // slider prezzo
    var fp = box.querySelector('filter-price');
    if (fp) {
      var ranges = fp.querySelectorAll('input[type="range"]');
      var fromLabel = fp.querySelector('[filter-price="from-label"]');
      var toLabel = fp.querySelector('[filter-price="to-label"]');
      var progress = fp.querySelector('[filter-price="progress"]');
      var max = parseInt(box.getAttribute('data-price-max') || '1000', 10);
      if (ranges.length === 2) {
        ranges.forEach(function (r) { r.min = 0; r.max = max; });
        var params0 = new URLSearchParams(location.search);
        ranges[0].value = params0.get('filter.v.price.gte') || 0;
        ranges[1].value = params0.get('filter.v.price.lte') || max;
        function paint() {
          var lo = Math.min(+ranges[0].value, +ranges[1].value);
          var hi = Math.max(+ranges[0].value, +ranges[1].value);
          if (fromLabel) fromLabel.textContent = formatMoney(lo * 100);
          if (toLabel) toLabel.textContent = formatMoney(hi * 100);
          if (progress) {
            progress.style.left = (lo / max * 100) + '%';
            progress.style.right = (100 - hi / max * 100) + '%';
          }
        }
        ranges.forEach(function (r) {
          r.addEventListener('input', paint);
          r.addEventListener('change', debounce(function () {
            var lo = Math.min(+ranges[0].value, +ranges[1].value);
            var hi = Math.max(+ranges[0].value, +ranges[1].value);
            var params = currentParams();
            params.delete('filter.v.price.gte');
            params.delete('filter.v.price.lte');
            if (lo > 0) params.set('filter.v.price.gte', lo);
            if (hi < max) params.set('filter.v.price.lte', hi);
            apply(params);
          }, 300));
        });
        paint();
      }
    }

    // paginazione ajax (load more / pagine)
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-filter-grid] .w-pagination-wrapper a, [data-filter-pagination] a');
      if (!a) return;
      e.preventDefault();
      var params = new URLSearchParams(a.search);
      apply(params);
      window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    });

    window.addEventListener('popstate', function () { apply(currentParams(), false); });
  }

  /* ---------- acquista ora + codice sconto ---------- */
  function setLoading(btn, loading) {
    var d = btn.querySelector('[data-state="default"]');
    var l = btn.querySelector('[data-state="loading"]');
    if (d) d.classList.toggle('is-hidden', loading);
    if (l) l.classList.toggle('is-hidden', !loading);
    btn.disabled = loading;
  }
  function bindExtras() {
    document.addEventListener('click', function (e) {
      var buyNow = e.target.closest('[data-buy-now]');
      if (buyNow) {
        e.preventDefault();
        var form = buyNow.closest('form');
        if (!form) return;
        setLoading(buyNow, true);
        fetch(O.cartAddUrl + '.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            setLoading(buyNow, false);
            alert((err && err.description) || 'Impossibile procedere al pagamento');
          });
        return;
      }
      var coupon = e.target.closest('[data-action="coupon"]');
      if (coupon) {
        e.preventDefault();
        var field = document.querySelector('[data-coupon-field]');
        var code = field && field.value.trim();
        if (!code) return;
        fetch('/discount/' + encodeURIComponent(code)).then(function () {
          coupon.querySelector('div').textContent = 'Codice applicato al checkout ✓';
          setTimeout(function () { location.reload(); }, 800);
        });
      }
    });
    // stato di caricamento sui submit add-to-cart
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.querySelector('[data-state]')) {
          setLoading(btn, true);
          setTimeout(function () { setLoading(btn, false); }, 4000);
        }
      }
    }, true);
  }

  /* ---------- pop-up ---------- */
  function bindPopup() {
    var pop = document.querySelector('.pop-up');
    if (!pop) return;
    try {
      if (localStorage.getItem('ob-popup-closed')) { pop.style.display = 'none'; return; }
    } catch (e) {}
    var close = pop.querySelector('.close-wrapper');
    if (close) close.addEventListener('click', function () {
      try { localStorage.setItem('ob-popup-closed', '1'); } catch (e) {}
    });
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    bindCart();
    bindSearch();
    bindProduct();
    bindFilters();
    bindExtras();
    bindPopup();
    loadCartUpsell();
  });
})();
